import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../features/counter/counterSlice';
import session from '../features/redux/sessionSlice';
import applications from '../features/redux/appSlice';
import notifications from '../features/redux/notificationsSlice';
import admin from '../features/redux/adminSlice';

export const store = configureStore({
  reducer: {
    counter: counterReducer,
    session: session,
    applications: applications,
    notifications: notifications,
    admin: admin,
  },
});
